import LinkifyModule from 'react-linkify';

const Linkify = LinkifyModule.default ?? LinkifyModule;

const componentDecorator = (href, text, key) => (
  <a href={href} key={key} target="_blank" rel="noopener noreferrer">
    {text}
  </a>
);

export default ({ children, ...props }) => (
  <Linkify componentDecorator={componentDecorator} {...props}>
    {children}
  </Linkify>
);
